import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button, Form, Grid, Header, Segment} from 'semantic-ui-react';
import {push} from 'react-router-redux';
import {Translate} from 'react-localize-redux';

import {createActivity} from "../../reducer/actions";



class ActivityCreate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            displayName: ''
        }
    }

    handleSubmit() {
        this.props.createActivity(this.state);
    }


    render() {
        return (
            <div>
                <Segment style={{padding: '8em 0em'}} vertical>
                    <Grid container stackable verticalAlign='middle' centered>
                        <Grid.Row>
                            <Grid.Column width={12}>
                                <Header as='h2' color='teal' textAlign='center'>
                                    <Translate id="admin.activity.create.header" />
                                </Header>
                                <Form size='large' onSubmit={() => {
                                    this.handleSubmit()
                                }}>
                                    <Segment stacked>
                                        <Translate>
                                            {
                                                ({translate}) =>
                                                    <div>

                                                        <Form.Input
                                                            label={translate("general.name")}
                                                            fluid
                                                            icon='lightning'
                                                            iconPosition='left'
                                                            placeholder={translate("general.name")}
                                                            type={'text'}
                                                            value={this.state.name}
                                                            onChange={(e) => {
                                                                this.setState({name: e.target.value})
                                                            }}
                                                        />

                                                        <Form.Input
                                                            label={translate("general.displayName")}
                                                            fluid
                                                            icon='lightning'
                                                            iconPosition='left'
                                                            placeholder={translate("general.displayName")}
                                                            type={'text'}
                                                            value={this.state.displayName}
                                                            onChange={(e) => {
                                                                this.setState({displayName: e.target.value})
                                                            }}
                                                        />

                                                        <Button type='submit'>{translate("general.save")}</Button>
                                                    </div>

                                            }

                                        </Translate>
                                    </Segment>
                                </Form>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Segment>
            </div>
        );
    }

}

const mapStateToProps = state => {
    return {}
};

const mapDispatchToProps = (dispatch) => {
    return ({
        createActivity: (activity) => {
            return dispatch(createActivity(activity)).then(() => {
                dispatch(push('/admin/activities'))
            })
        },
    });
};


function mergeProps(stateProps, dispatchProps, ownProps) {
    return {

        ...stateProps,
        ...ownProps,
        ...dispatchProps,

    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(ActivityCreate)



// WEBPACK FOOTER //
// ./src/scenes/Admin/scenes/ActivityCreate/index.js